import React from 'react';
import { CheckIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const items = ['Alle 10 kompletten Bände (Band 1–10).', 'Projekte, Vorlagen und Arbeitsblätter für jede Klassenstufe.', 'Schritt-für-Schritt-Bildfolgen, leicht nachvollziehbar.', 'Fertige Vertretungsstunden — 3 in jedem Band.', 'Sofort einsetzbar — zum Ausdrucken oder digital am Whiteboard.', 'Druck so oft du willst — nie wieder Materialsorgen.'];
export function InstantAccessSection() {
  return <section className="bg-brand-alt px-4 py-20 md:py-24" data-id="element-97" data-mp="1reor7pryvp4l">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-98" data-mp="1rg86bd1vzu4s">
        <h2 className="mb-10 flex items-center justify-center gap-3 text-3xl font-extrabold text-brand-navy md:text-4xl" data-id="element-99" data-mp="25cdcgypy4ya6">
          <ZapIcon className="h-7 w-7 shrink-0 text-brand-orange" aria-hidden="true" data-id="element-100" data-mp="20fd2wdtw1deb" />
          Was bekommst du sofort?
        </h2>
        <ul className="space-y-4 rounded-3xl border border-brand-line bg-brand-main p-7 text-left shadow-sm md:p-10" data-id="element-101" data-mp="61lxjqildfoo">
          {items.map(item => <li key={item} className="flex items-start gap-4" data-id="element-102" data-mp="2mzu8mfmjn6ge">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-orange/10 text-brand-orange" data-id="element-103" data-mp="2s19q5xpiiuu1">
                <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-104" data-mp="31qkyhi4krvgv" />
              </span>
              <span className="text-sm font-semibold leading-snug md:text-base" data-id="element-105" data-mp="35u94vxhh0l0j">
                {item}
              </span>
            </li>)}
        </ul>
        <p className="mt-10 font-script text-2xl italic text-brand-orange" data-id="element-106" data-mp="3frnm3zb7xdtw">
          Dir geht nie das Material aus.
        </p>
      </Reveal>
    </section>;
}